import { createFileRoute, redirect } from '@tanstack/react-router';
import { getCurrentAppState } from 'merchant-api/derived';

export const Route = createFileRoute('/application/$id/')({
  loader: async ({ params }) => {
    const result = await getCurrentAppState({ id: params?.id });
    if (!result) throw redirect({ to: '/apply/landing' });
    throw redirect({ to: `/application/$id/${result.state || 'apply'}`, params: { id: result.id } });
  },
});
